import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';

export const componentKey = "FORMS/MANAGE_FORMS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setFederalPayers: (state, action) => {
            state.federalPayers = action.payload
        },

        setFederalTaxYear: (state, action) => {
            state.federalTaxYear = action.payload
        },

        setFederalForms: (state, action) => {
            state.federalForms = action.payload
        },

        setCurrentTabIndex: (state, action) => {
            state.currentTabIndex = action.payload
        },

        setManageFormsLoad: (state, action) => {
            state.manageFormsLoad = action.payload
        },

        setFederalPayersLoader: (state, action) => {
            state.federalPayersLoader = action.payload;
        },

        setFederalTaxYearsLoader: (state, action) => {
            state.federalTaxYearsLoader = action.payload;
        },

        setViewTin:(state)=>{
            state.isTINHidden = !state.isTINHidden
        }

    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.LOADING, message: "" },
        federalPayersLoader: { state: PAGE_STATE.PAGE_READY, message: "" },
        federalTaxYearsLoader: { state: PAGE_STATE.PAGE_READY, message: "" },
        federalPayers: [],
        federalTaxYear: [],
        federalForms: [],
        currentTabIndex: 0,
        manageFormsLoad: [],
        isTINHidden: true
    }
})

export const { setLoadingState, setFederalPayers, setFederalTaxYear, setFederalForms, setCurrentTabIndex, setManageFormsLoad, setFederalPayersLoader, setFederalTaxYearsLoader, setViewTin } = actions; 